export default "__VITE_IMAGE_ASSET__b7d638f2__";